import { render, staticRenderFns } from "./bucketAdmin.vue?vue&type=template&id=96d5cbd4&scoped=true&"
import script from "./bucketAdmin.vue?vue&type=script&lang=js&"
export * from "./bucketAdmin.vue?vue&type=script&lang=js&"
import style0 from "./bucketAdmin.vue?vue&type=style&index=0&id=96d5cbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5cbd4",
  null
  
)

export default component.exports